<template>
  <v-row dense>
    <v-col
      v-for="(card, key) in summaryCards"
      :key="key"
      xl
      lg="4"
      md="4"
      sm="12"
    >
      <ActivityCard
        style="height: 100%"
        :class="key"
        :count="card.count"
        :label="card.label"
        :icon="card.icon"
        :iconColor="card.iconColor"
        :color="card.color"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

import mixin from '@/mixins/mixin.vue'

import ActivityCard from '@/components/Activity/ActivityCard.vue'

export default {
  name: 'InsightsSummary',

  mixin: [mixin],

  components: {
    ActivityCard,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },
    teamActivity: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['organization']),
  },

  data() {
    return {
      summaryCards: {},
    }
  },

  mounted() {
    this.summaryCards = {
      quickActions: {
        count: this.teamActivity.quickAction,
        label:
          this.organization.customNamings.quickAction.plural ||
          this.$t('common.rev_type.quick_action_other'),
        icon: 'mdi-lightning-bolt-outline',
        iconColor: 'orange',
        color: 'orange lighten-2',
      },
      improvementIdeas: {
        count: this.teamActivity.improvementIdea,
        label:
          this.organization.customNamings.improvementIdea.plural ||
          this.$t('common.rev_type.improvement_idea_other'),
        icon: 'mdi-lightbulb-outline',
        iconColor: 'blue darken-1',
        color: 'blue lighten-2',
      },
      problemSolving: {
        count: this.teamActivity.problemSolving,
        label:
          this.organization.customNamings.problemSolving.plural ||
          this.$t('common.rev_type.problem_solving_other'),
        icon: 'mdi-puzzle-outline',
        iconColor: 'red',
        color: 'red lighten-2',
      },
      totals: {
        count: this.teamActivity.allRevs,
        label: this.$t('common.total_revs'),
        color: '#e2e8f0',
      },
      routines: {
        count: this.teamActivity.routine ?? 0,
        label: this.$t('routines.routine_other'),
        icon: 'mdi-clipboard-text-outline',
        iconColor: 'teal darken-1',
        color: 'teal lighten-2',
      },
    }
  },
}
</script>

<style scoped lang="scss">
.quickActions {
  &.activity-card {
    box-shadow: inset 6px 0px 0px $color-orange-lighten2;
  }
}

.improvementIdeas {
  &.activity-card {
    box-shadow: inset 6px 0px 0px $color-purple-lighten2;
  }
}

.problemSolving {
  &.activity-card {
    box-shadow: inset 6px 0px 0px $color-blue-lighten2;
  }
}

.totals {
  &.activity-card {
    box-shadow: inset 6px 0px 0px $color-blue-grey-lighten2;
  }
}
</style>
